import {
  addressValidations,
  required,
  validDateInFuture,
  validDateInPast,
  verifyEmploymentId,
} from '../../utils/validations'

const validate = ({
  employedSince,
  employedTo,
  employerAddress,
  employerId,
  employerName,
}: any) => ({
  employedSince: required(employedSince) || validDateInPast(employedSince),
  employedTo: required(employedTo) || validDateInFuture(employedTo),
  employerAddress: addressValidations(employerAddress),
  employerId: required(employerId) || verifyEmploymentId(employerId),
  employerName: required(employerName),
})

export default validate
